/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./intercomFoot.vue?vue&type=template&id=f2ce55ec&scoped=true&"
import script from "./intercomFoot.vue?vue&type=script&lang=js&"
export * from "./intercomFoot.vue?vue&type=script&lang=js&"
import style0 from "./intercomFoot.vue?vue&type=style&index=0&id=f2ce55ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ce55ec",
  null
  
)

export default component.exports